// extracted by mini-css-extract-plugin
export default {"contracts":"contract-customer_financial_contracts__l57YK"};